import CancelLationsManage from "./cancel_lations_manage";

export default CancelLationsManage;
